module.exports = __webpack_public_path__ + "img/popup-bg.59914597.png";